;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .factory('vulnRequestService', vulnRequestServiceFactory)

  function vulnRequestServiceFactory($uibModal) {
    'ngInject'

    return {
      showRequest: showRequest
    }

    /**
     * @description Opens a modal window
     * @param {{}} opts - any valid $uibModal.open() options
     * @return {promise} returns a $uibModal.open().result promise object
     */
    function showRequest(opts) {
      var modalOpts = {
        templateUrl: 'views/applications/traces/modal_request.html',
        controller: 'TraceRequestModalInstanceCtrl',
        size: 'lg'
      }
      if (angular.isObject(opts)) {
        modalOpts = angular.extend(modalOpts, opts)
      }
      return $uibModal.open(modalOpts).result
    }
  }
})()
